import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/jbqez8LVwuJ5Dpw975rfjw/Screenshot_1.png', 'https://cdn.magicpatterns.com/uploads/e8iXoFyyfDqMzAXgbVUVaL/Screenshot_2.png', 'https://cdn.magicpatterns.com/uploads/tuUVxCRvzUnM5xJafaG2AB/Screenshot_3.png', 'https://cdn.magicpatterns.com/uploads/hbhVu4wFr67zvLMb9p43mp/Screenshot_4.png', 'https://cdn.magicpatterns.com/uploads/9rE4UxBzcqBLB62Kt4rJzm/Screenshot_5.png'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <div className="max-w-3xl mx-auto text-center" data-id="element-254">
      <h2 className="text-2xl md:text-4xl font-bold mb-8 text-brand-petroleum tracking-tight" data-id="element-255">
        📸 Mirá el material por dentro
      </h2>

      <div className="flex items-center justify-between mb-6 text-brand-medium-grey px-4" data-id="element-256">
        <button onClick={prev} className="p-2.5 hover:text-brand-gold-warm transition-all bg-white rounded-full shadow-premium border border-brand-petroleum/5" aria-label="Anterior" data-id="element-257">
          <ChevronLeft size={20} data-id="element-258" />
        </button>

        <span className="uppercase tracking-[0.2em] text-brand-medium-grey text-[10px] font-bold" data-id="element-259">
          Desliza para ver más
        </span>

        <button onClick={next} className="p-2.5 hover:text-brand-gold-warm transition-all bg-white rounded-full shadow-premium border border-brand-petroleum/5" aria-label="Siguiente" data-id="element-260">
          <ChevronRight size={20} data-id="element-261" />
        </button>
      </div>

      <div className="relative aspect-[3/4] md:aspect-[4/5] overflow-hidden mb-8 rounded-[40px] bg-white shadow-2xl flex items-center justify-center max-w-xl mx-auto p-4 md:p-6" data-id="element-262">
        <AnimatePresence mode="wait" data-id="element-263">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="w-full h-full flex items-center justify-center" data-id="element-264">
            <img src={images[currentIndex]} alt={`Vista previa del material ${currentIndex + 1}`} className="w-full h-full object-contain drop-shadow-xl rounded-xl" width="600" height="800" loading="lazy" data-id="element-265" />
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="flex justify-center gap-4" data-id="element-266">
        {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 rounded-full transition-all duration-500 ${idx === currentIndex ? 'w-12 bg-brand-gold-warm' : 'w-3 bg-brand-medium-grey/20'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-267" />)}
      </div>
    </div>;
}